// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2dMMS","row":"ProcedureTreatmentSummary_row__2j_HP"};